import type { IValidationError, IValidationResult } from './types';

export function getGeneralizedErrors(...results: IValidationResult[]): IValidationError[] {
    return ([] as IValidationError[]).concat.apply(
        [],
        results.filter(r => r.success === false).map(r => r.errors?.map((err: IValidationError) => err) ?? [])
    );
}
